<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">ボックス</div>
    <div class="text-subtitle2">フッターのスタイル設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select outlined dense emit-value map-options v-model="value.type" :options="typeList" class="col" disable>
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>レイアウト<span class="text-brand-red">*</span></div>
        <div class="text-caption">layout</div>
      </div>
      <q-select outlined dense v-model="value.layout" :options="['baseline', 'horizontal', 'vertical']" class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>ポジション</div>
        <div class="text-caption">position</div>
      </div>
      <q-select outlined dense v-model="value.position" :options="['', 'relative', 'absolute']" class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フレックス</div>
        <div class="text-caption">Flex</div>
      </div>
      <q-input outlined dense type="number" min="0" v-model.number="value.flex" placeholder="Num." class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>スペース</div>
        <div class="text-caption">spacing</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.spacing"
        :rules="[(val) => spacingMarginValidate(val) || 'invalid property']"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px or keywords">
            <q-list>
              <q-item
                v-for="(item, index) in spacingMarginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.spacing = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>マージン</div>
        <div class="text-caption">margin</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.margin"
        :rules="[(val) => spacingMarginValidate(val) || 'invalid property']"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px or keywords">
            <q-list>
              <q-item
                v-for="(item, index) in spacingMarginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.margin = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>幅</div>
        <div class="text-caption">width</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.width"
        :rules="[(val) => widthHeightValidate(val) || 'invalid property']"
        placeholder="Num. px or %"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>高さ</div>
        <div class="text-caption">height</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.height"
        :rules="[(val) => widthHeightValidate(val) || 'invalid property']"
        placeholder="Num. px or %"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>最大幅</div>
        <div class="text-caption">maxWidth</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.maxWidth"
        :rules="[(val) => widthHeightValidate(val) || 'invalid property']"
        placeholder="Num. px or %"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>最大高さ</div>
        <div class="text-caption">maxHeight</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.maxHeight"
        :rules="[(val) => widthHeightValidate(val) || 'invalid property']"
        placeholder="Num. px or %"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>背景色</div>
        <div class="text-caption">backgroundColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.backgroundColor"
        :rules="[(val) => colorValidate(val) || 'invalid property']"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.backgroundColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>罫線幅</div>
        <div class="text-caption">borderWidth</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.borderWidth"
        :rules="[(val) => borderValidate(val) || 'invalid property']"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px or keywords">
            <q-list>
              <q-item
                v-for="(item, index) in borderList"
                clickable
                v-close-popup
                :key="index"
                @click="value.borderWidth = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>罫線色</div>
        <div class="text-caption">borderColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.borderColor"
        :rules="[(val) => colorValidate(val) || 'invalid property']"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.borderColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>角の丸み</div>
        <div class="text-caption">cornerRadius</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.cornerRadius"
        :rules="[(val) => spacingMarginValidate(val) || 'invalid property']"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown no-caps unelevated color="brand-grey" label="px or keywords">
            <q-list>
              <q-item
                v-for="(item, index) in spacingMarginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.cornerRadius = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>主軸配置</div>
        <div class="text-caption">justifyContent</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.justifyContent"
        :options="['', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around', 'space-evenly']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>交差軸配置</div>
        <div class="text-caption">alignItems</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.alignItems"
        :options="['', 'center', 'flex-start', 'flex-end']"
        class="col"
      />
    </div>
    <q-separator class="q-my-md" />
    <Offset v-model="value" />
    <q-separator class="q-my-md" />
    <Padding v-model="value" />
    <q-separator class="q-my-md" />
    <Background v-model="value.background" />
    <q-separator class="q-my-md" />
    <Action v-model="value.action" />
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBox, IFlexMessageURIAction } from '@/utils/types'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import Padding from '@/components/common/flex-message/forms/Padding.vue'
import Action from '@/components/common/flex-message/forms/Action.vue'
import Background from '@/components/common/flex-message/forms/Background.vue'

@Options({
  components: { Background, Action, Padding, Offset },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Box extends Vue {
  @Prop()
  modelValue!: IFlexMessageBox

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBox) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'ボックス',
        value: 'box',
      },
    ]
  }

  get spacingMarginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get borderList() {
    return ['none', 'light', 'normal', 'medium', 'semi-bold', 'bold']
  }

  widthHeightValidate(val) {
    if (!val) return true
    return /^(\d+(\.\d+)?)(px|%)$/.test(val)
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  spacingMarginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.spacingMarginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  borderValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.borderList.includes(val)
    return !(!isPx && !isKeyword)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
</script>

<style scoped lang="scss">
</style>
